export function formatDate (time, fmt = 'yyyy-MM-dd hh:mm:ss') {
    let date = []
    if (typeof time === 'object') {
        date    = time
    } else if (typeof time === 'number') {
        if (time > 0) {
            date    = new Date(time * 1000)
        } else {
            return time
        }
    } else {
        date    = new Date(time)
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
        }
    }
    return fmt
}
function padLeftZero (str) {
    return ('00' + str).substr(str.length)
}



// WEBPACK FOOTER //
// ./src/utils/date.js